import { useState } from 'react';
import i18next from 'i18next';
import { aggregateByCoalition } from '../../utils/coalitionLookup';

const AllianceList = ({ election }) => {
  // Tracks rows the user has explicitly collapsed; rows default to open.
  const [closed, setClosed] = useState({});
  const groups = aggregateByCoalition(election);
  const total = election.totalSeats || groups.reduce((a, b) => a + b.seats, 0);

  return (
    <div className="alliance-list">
      {groups.map((g) => {
        const pct = total > 0 ? (g.seats / total) * 100 : 0;
        const isOpen = !closed[g.coalition];
        const isWinner = g.coalition === election.winningCoalition
          || election.winningCoalition?.includes(g.coalition);
        return (
          <div key={g.coalition} className={`alliance-row ${isOpen ? 'is-open' : ''}`}>
            <button
              type="button"
              className="alliance-row__head"
              onClick={() => setClosed((c) => ({ ...c, [g.coalition]: !c[g.coalition] }))}
              aria-expanded={isOpen}
            >
              <span className="alliance-row__swatch" style={{ backgroundColor: g.color }} />
              <span className="alliance-row__name">
                {g.coalition}
                {isWinner && <span className="alliance-row__badge">{i18next.t('执政')}</span>}
              </span>
              <span className="alliance-row__count">{g.seats} / {total}</span>
              <span className="alliance-row__bar">
                <span
                  className="alliance-row__bar-fill"
                  style={{ width: `${pct}%`, backgroundColor: g.color }}
                />
              </span>
              <span className="alliance-row__caret" aria-hidden="true">{isOpen ? '▾' : '▸'}</span>
            </button>
            {isOpen && g.parties.length > 0 && (
              <ul className="alliance-row__parties">
                {g.parties.map((p) => (
                  <li key={p.party}>
                    <span className="alliance-row__party-name">{p.party}</span>
                    <span className="alliance-row__party-seats">{p.seats}</span>
                  </li>
                ))}
              </ul>
            )}
            {isOpen && g.parties.length === 0 && (
              <div className="alliance-row__empty">
                {i18next.t('明细未提供')}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AllianceList;
